export default __webpack_public_path__ + "static/media/copper.4ea5f04b.png";